import { v4 as uuid } from 'uuid'

export default class Vessel {
  id = null
  name = null
  tonnage = null
  alternate_name = null
  documents = {}
  is_new = false

  uuid = uuid()

  constructor (object) {
    if (object) {
      Object.assign(this, object)
    }
  }

  formatDocuments () {
    return Object.fromEntries(Object.entries(this.documents).map(([key, documents]) => [key, documents.map(document => document.meta)]))
  }

  get formData () {
    return { ...this, documents: this.formatDocuments() }
  }
}
